import Forms, { IFormQuestion, IMembershipCustomFieldGroup } from '@/models/Forms'
import { FormsService } from '@/service/FormsService'
import { reactive } from 'vue'

import { GroupState } from './groups'

type FormData = {
  locationId: string
  groupId: string
  questions: IFormQuestion[]
}
export class FormsState {
  state = reactive({
    membershipQuestions: {} as Forms,
    customFieldGroups: [] as IMembershipCustomFieldGroup[],
    customFieldsLoading: false,
    customFieldsError: false,
  })
  async upsertGroupFormData(formData: FormData): Promise<any> {
    this.state.membershipQuestions = await FormsService.create(formData)

    // here we are updating the group data with the form id becuase its updated in BE in the DB
    GroupState.state.groupData.settings.formId = this.state.membershipQuestions._id
    GroupState.state.updatedGroupData.settings.formId = this.state.membershipQuestions._id
    return this.state.membershipQuestions
  }
  async getGroupFormData(formId: string): Promise<any> {
    const forms = await FormsService.findById(formId)
    this.state.membershipQuestions = forms
    return forms
  }
  async fetchCustomFields(): Promise<IMembershipCustomFieldGroup[]> {
    this.state.customFieldsLoading = true
    this.state.customFieldsError = false
    try {
      const groups = await FormsService.fetchCustomFields()
      this.state.customFieldGroups = Array.isArray(groups) ? groups : []
      return this.state.customFieldGroups
    } catch (error) {
      this.state.customFieldsError = true
      this.state.customFieldGroups = []
      throw error
    } finally {
      this.state.customFieldsLoading = false
    }
  }
}
export const FormState = new FormsState()
